<template>
  <BaseTemplate app-name="Gestão de Usuários" page-title="">
    <template #content>
      <div class="container mx-auto p-6">
        <!-- Cabeçalho -->
        <button
          @click="voltar"
          class="hidden md:inline-flex mb-5 items-center gap-2 clinic-btn text-white px-4 py-2 rounded hover:bg-blue-600 transition-colors"
        >
          <SquareArrowLeft class="w-5 h-5" />
          <span>Voltar</span>
        </button>
        <div class="flex justify-between items-center mb-6">
          <h1 class="flex items-center gap-2 text-2xl font-bold" :style="{ color: 'var(--clinic-font-color)' }">
            <BriefcaseIcon class="w-6 h-6" :style="{ color: 'var(--clinic-icon-color)' }" />
            Gestão de Usuários
          </h1>
          <button @click="openModal()"
            class="flex items-center gap-2 clinic-btn text-white px-4 py-2 rounded-lg shadow">
            <UserPlusIcon class="w-5 h-5" />
            Novo Usuário
          </button>
        </div>

        <!-- Filtros -->
        <div class="flex flex-col sm:flex-row gap-4 mb-6">
          <input v-model="filter" type="text" placeholder="Buscar por nome, usuário ou email..."
            class="w-full sm:w-1/2 border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 focus:ring-2 focus:ring-opacity-50 input-font-color" />
        </div>

        <!-- Tabela para telas maiores -->
        <div class="hidden sm:block bg-white dark:bg-gray-800 rounded-lg shadow overflow-x-auto">
          <table class="w-full">
            <thead class="bg-gray-50 dark:bg-gray-700 text-sm uppercase tracking-wide rounded-t-lg">
              <tr>
                <th @click="ordenarPor('nome')" class="cursor-pointer px-4 py-3 text-left" :style="{ color: 'var(--clinic-font-color)' }">
                  Nome <span v-if="colunaOrdenada === 'nome'">{{ ordemAscendente ? '🠕' : '🠗' }}</span>
                </th>
                <th @click="ordenarPor('usuario')" class="cursor-pointer px-4 py-3 text-left" :style="{ color: 'var(--clinic-font-color)' }">
                  Usuário <span v-if="colunaOrdenada === 'usuario'">{{ ordemAscendente ? '🠕' : '🠗' }}</span>
                </th>
                <th @click="ordenarPor('email')" class="cursor-pointer px-4 py-3 text-left" :style="{ color: 'var(--clinic-font-color)' }">
                  Email <span v-if="colunaOrdenada === 'email'">{{ ordemAscendente ? '🠕' : '🠗' }}</span>
                </th>
                <th @click="ordenarPor('status')" class="cursor-pointer px-4 py-3 text-left" :style="{ color: 'var(--clinic-font-color)' }">
                  Status <span v-if="colunaOrdenada === 'status'">{{ ordemAscendente ? '🠕' : '🠗' }}</span>
                </th>
                <th class="px-4 py-3 text-center" :style="{ color: 'var(--clinic-font-color)' }">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in paginatedUsers" :key="user.id"
                class="border-b dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700">
                <td class="px-4 py-3 input-font-color">{{ getUserFullName(user) }}</td>
                <td class="px-4 py-3 input-font-color">{{ user.username || 'Usuário não informado' }}</td>
                <td class="px-4 py-3 input-font-color">{{ user.email || '-' }}</td>
<td class="px-4 py-3 text-center">
  <label
    class="flex w-full h-full justify-center items-center cursor-pointer"
  >
    <input
      type="checkbox"
      class="sr-only"
      :checked="user.isActive"
      @change="toggleUserActive(user, $event)"
    />
    <ToggleRight
      v-if="user.isActive"
      class="w-6 h-6"
      stroke="var(--clinic-icon-color)"
      fill="none"
      @click="toggleUserActiveFromClick(user)"
    />
    <ToggleLeft
      v-else
      class="w-6 h-6"
      stroke="var(--clinic-font-color)"
      fill="none"
      @click="toggleUserActiveFromClick(user)"
    />
  </label>
</td>

                <td class="px-4 py-3 text-center">
                  <div class="flex justify-center space-x-2">
                    <button @click="openModal(user)" class="flex items-center gap-1" :style="{ color: 'var(--clinic-icon-color)' }">
                      <Edit2Icon class="w-4 h-4" /> Editar
                    </button>
                    <button @click="deleteUser(user.id)" class="flex items-center gap-1 text-red-500 hover:text-red-700">
                      <Trash2Icon class="w-4 h-4" /> Excluir
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginação -->
        <div class="flex justify-between items-center mt-4">
          <button @click="prevPage" :disabled="currentPage === 1"
            class="clinic-btn px-4 py-2 text-white rounded-lg shadow disabled:opacity-50">
            Anterior
          </button>
          <span class="input-font-color">Página {{ currentPage }} de {{ totalPages }}</span>
          <button @click="nextPage" :disabled="currentPage >= totalPages"
            class="clinic-btn px-4 py-2 text-white rounded-lg shadow disabled:opacity-50">
            Próxima
          </button>
        </div>

        <!-- Mensagem de erro -->
        <p v-if="error" class="text-red-500 text-center mb-4">{{ error }}</p>

        <!-- Versão mobile em cards -->
        <div class="sm:hidden space-y-6">
          <div v-for="user in usuariosOrdenados" :key="user.id"
            class="bg-white dark:bg-gray-900 shadow-lg rounded-xl p-6 border border-gray-100 dark:border-gray-700 transition transform hover:scale-105">
            <div class="flex justify-between items-center">
              <h3 class="text-xl font-bold text-gray-900 dark:text-white">
                {{ getUserFullName(user) }}
              </h3>
              <div class="flex items-center gap-2">
                <button @click="openModal(user)" class="text-blue-500 hover:text-blue-700">
                  <Edit2Icon class="w-5 h-5" />
                </button>
                <button @click="deleteUser(user.id)" class="text-red-500 hover:text-red-700">
                  <Trash2Icon class="w-5 h-5" />
                </button>
              </div>
            </div>
            <p class="text-sm text-gray-700 dark:text-gray-300"><strong>Usuário:</strong> {{ user.username || 'Usuário não informado' }}</p>
            <p class="text-sm text-gray-700 dark:text-gray-300"><strong>Email:</strong> {{ user.email || '-' }}</p>
            <div class="flex items-center justify-between mt-4">
              <label class="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" class="sr-only peer" :checked="user.isActive"
                  @change="toggleUserActive(user, $event)">
                <div class="flex items-center gap-1 cursor-pointer transition-all"
                  :style="{ color: user.isActive ? 'var(--clinic-icon-color)' : 'var(--clinic-font-color)' }" 
                  @click="toggleUserActiveFromClick(user)">
                  <span>{{ user.isActive ? 'Ativo' : 'Inativo' }}</span>
                  <ToggleRight v-if="user.isActive" class="w-8 h-8 transition-all" />
                  <ToggleLeft v-else class="w-8 h-8 transition-all" />

                </div>
              </label>
            </div>
          </div>
        </div>

        <!-- Modal -->
        <div v-if="isModalOpen" 
            class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
            @click.self="closeModal">
          <div class="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-96 animate-fade-in">
            <h2 class="flex items-center gap-2 text-lg font-semibold mb-4" :style="{ color: 'var(--clinic-font-color)' }">
              <UserIcon class="w-5 h-5" :style="{ color: 'var(--clinic-icon-color)' }" />
              {{ isEditMode ? 'Editar Usuário' : 'Novo Usuário' }}
            </h2>

            <!-- Alerta de erro dentro do modal -->
            <div v-if="showErrorPopup" class="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded relative mb-4">
              <strong>Erro:</strong> {{ errorMessage }}
              <button @click="showErrorPopup = false" class="absolute top-0 right-0 px-3 py-1">
                &times;
              </button>
            </div>

            <label class="block text-sm font-medium mb-1 input-font-color">Primeiro Nome</label>
            <input v-model="currentUser.first_name" type="text"
                  class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 mb-3 input-font-color" />

            <label class="block text-sm font-medium mb-1 input-font-color">Sobrenome</label>
            <input v-model="currentUser.last_name" type="text"
                  class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 mb-3 input-font-color" />

            <label class="block text-sm font-medium mb-1 input-font-color">Email</label>
            <input v-model="currentUser.email" type="email"
                  class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 mb-3 input-font-color" />

            <label class="block text-sm font-medium mb-1 input-font-color">Senha</label>
            <input v-model="currentUser.password" type="password"
                  class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 mb-3 input-font-color" />

            <div class="flex justify-end space-x-3">
              <button @click="closeModal"
                      class="flex items-center gap-1 bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg">
                <XIcon class="w-4 h-4" /> Cancelar
              </button>
              <button @click="saveUser"
                      class="flex items-center gap-1 clinic-btn text-white px-4 py-2 rounded-lg">
                <SaveIcon class="w-4 h-4" />
                <span>Salvar</span>
              </button>
            </div>
          </div>
        </div>

        <!-- Modal de Confirmação de Exclusão -->
        <div v-if="isDeleteConfirmationModalOpen" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div class="bg-white dark:bg-gray-800 rounded-lg max-w-md w-full" @click.stop>
            <div class="flex justify-between items-center p-4 border-b border-gray-200 dark:border-gray-700">
              <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Confirmar Exclusão</h3>
              <button @click="closeDeleteConfirmationModal" class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
                <XIcon class="w-5 h-5" />
              </button>
            </div>
            
            <div class="p-6">
              <div class="flex items-center gap-3 mb-4">
                <div class="w-12 h-12 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center">
                  <Trash2Icon class="w-6 h-6 text-red-600 dark:text-red-400" />
                </div>
                <div>
                  <h4 class="text-lg font-semibold text-gray-900 dark:text-white">Excluir Usuário</h4>
                  <p class="text-sm text-gray-600 dark:text-gray-400">
                    Tem certeza que deseja excluir o usuário <strong>{{ getUserFullName(deleteConfirmationUser) }}</strong>?
                  </p>
                </div>
              </div>
              
              <div class="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-700 rounded-lg p-4 mb-4">
                <div class="flex items-start">
                  <div class="flex-shrink-0">
                    <svg class="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                    </svg>
                  </div>
                  <div class="ml-3">
                    <p class="text-sm text-yellow-800 dark:text-yellow-200">
                      <strong>Atenção:</strong> Esta ação não pode ser desfeita. Considere desabilitar o usuário em vez de excluí-lo.
                    </p>
                  </div>
                </div>
              </div>
              
              <div class="flex justify-end space-x-3">
                <button @click="closeDeleteConfirmationModal" 
                        class="flex items-center gap-2 px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors">
                  <XIcon class="w-4 h-4" />
                  Cancelar
                </button>
                <button @click="confirmDeleteUser" 
                        class="flex items-center gap-2 px-4 py-2 text-white bg-red-600 rounded-lg hover:bg-red-700 transition-colors">
                  <Trash2Icon class="w-4 h-4" />
                  Excluir Usuário
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal de Confirmação de Status -->
        <div v-if="isStatusConfirmationModalOpen" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div class="bg-white dark:bg-gray-800 rounded-lg max-w-md w-full" @click.stop>
            <div class="flex justify-between items-center p-4 border-b border-gray-200 dark:border-gray-700">
              <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Confirmar Alteração</h3>
              <button @click="closeStatusConfirmationModal" class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
                <XIcon class="w-5 h-5" />
              </button>
            </div>
            
            <div class="p-6">
              <div class="flex items-center gap-3 mb-4">
                <div class="w-12 h-12 rounded-full flex items-center justify-center"
                     :class="statusConfirmationData?.newStatus ? 'bg-green-100 dark:bg-green-900/30' : 'bg-orange-100 dark:bg-orange-900/30'">
                  <ToggleRight v-if="statusConfirmationData?.newStatus" class="w-6 h-6 text-green-600 dark:text-green-400" />
                  <ToggleLeft v-else class="w-6 h-6 text-orange-600 dark:text-orange-400" />
                </div>
                <div>
                  <h4 class="text-lg font-semibold text-gray-900 dark:text-white">
                    {{ statusConfirmationData?.newStatus ? 'Habilitar' : 'Desabilitar' }} Usuário
                  </h4>
                  <p class="text-sm text-gray-600 dark:text-gray-400">
                    Tem certeza que deseja <strong>{{ statusConfirmationData?.newStatus ? 'habilitar' : 'desabilitar' }}</strong> o usuário 
                    <strong>{{ getUserFullName(statusConfirmationData?.user) }}</strong>?
                  </p>
                </div>
              </div>
              
              <div v-if="!statusConfirmationData?.newStatus" class="bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-700 rounded-lg p-4 mb-4">
                <div class="flex items-start">
                  <div class="flex-shrink-0">
                    <svg class="h-5 w-5 text-orange-400" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                    </svg>
                  </div>
                  <div class="ml-3">
                    <p class="text-sm text-orange-800 dark:text-orange-200">
                      <strong>Atenção:</strong> Usuários desabilitados não conseguem acessar o sistema.
                    </p>
                  </div>
                </div>
              </div>
              
              <div v-else class="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-700 rounded-lg p-4 mb-4">
                <div class="flex items-start">
                  <div class="flex-shrink-0">
                    <svg class="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                    </svg>
                  </div>
                  <div class="ml-3">
                    <p class="text-sm text-green-800 dark:text-green-200">
                      <strong>Sucesso:</strong> O usuário terá acesso completo ao sistema.
                    </p>
                  </div>
                </div>
              </div>
              
              <div class="flex justify-end space-x-3">
                <button @click="closeStatusConfirmationModal" 
                        class="flex items-center gap-2 px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors">
                  <XIcon class="w-4 h-4" />
                  Cancelar
                </button>
                <button @click="confirmStatusChange" 
                        class="flex items-center gap-2 px-4 py-2 text-white rounded-lg transition-colors"
                        :class="statusConfirmationData?.newStatus ? 'bg-green-600 hover:bg-green-700' : 'bg-orange-600 hover:bg-orange-700'">
                  <ToggleRight v-if="statusConfirmationData?.newStatus" class="w-4 h-4" />
                  <ToggleLeft v-else class="w-4 h-4" />
                  {{ statusConfirmationData?.newStatus ? 'Habilitar' : 'Desabilitar' }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Banner Message -->
        <BannerMessage
          v-if="banner.show"
          :type="banner.type"
          :message="banner.message"
          @close="closeBanner"
        />
      </div>
      <p class="text-center text-sm mb-11 mt-10 input-font-color">
        Desenvolvido por Tecnologia da Informação - CCDTI © Todos os direitos reservados
      </p>
    </template>
  </BaseTemplate>
</template>

<script setup>
const showErrorPopup = ref(false);
const errorMessage = ref('');
import BaseTemplate from '../templates/BaseTemplate.vue';
import { ref, computed, onMounted } from 'vue';
import apiClient from '@/services/authService';
import BannerMessage from '@/components/BannerMessage.vue';
import {
  BriefcaseIcon,
  UserPlusIcon,
  Edit2Icon,
  Trash2Icon,
  UserIcon,
  SquareArrowLeft,
  XIcon,
  SaveIcon,
  ToggleLeft,
  ToggleRight
} from 'lucide-vue-next';

const users = ref([]);
const filter = ref('');
const error = ref(null);
const isModalOpen = ref(false);
const isEditMode = ref(false);
const isDeleteConfirmationModalOpen = ref(false);
const deleteConfirmationUser = ref(null);
const isStatusConfirmationModalOpen = ref(false);
const statusConfirmationData = ref(null);
const currentUser = ref({
  id: '',
  first_name: '',
  last_name: '',
  username: '',
  email: '',
  password: '',
  isActive: true
});

// Banner message
const banner = ref({ show: false, type: 'success', message: '' });

function showBanner(type, message) {
  banner.value = { show: true, type, message };
}

function closeBanner() {
  banner.value.show = false;
}

// Variáveis para ordenação
const colunaOrdenada = ref('nome'); // Coluna padrão para ordenação
const ordemAscendente = ref(true); // Ordem ascendente por padrão

// Filtra os usuários com base no campo de busca
const filteredUsers = computed(() =>
  users.value.filter(user =>
    ((user.first_name || '') + ' ' + (user.last_name || ''))
      .toLowerCase()
      .includes(filter.value.toLowerCase()) ||
    (user.username || '').toLowerCase().includes(filter.value.toLowerCase()) ||
    (user.email || '').toLowerCase().includes(filter.value.toLowerCase())
  )
);

// Ordena os usuários com base na coluna selecionada
const usuariosOrdenados = computed(() => {
  const usuariosFiltrados = filteredUsers.value.slice(); // Cria uma cópia dos usuários filtrados

  return usuariosFiltrados.sort((a, b) => {
    let valorA, valorB;

    switch (colunaOrdenada.value) {
      case 'nome':
        valorA = `${a.first_name} ${a.last_name}`.toLowerCase();
        valorB = `${b.first_name} ${b.last_name}`.toLowerCase();
        break;
      case 'usuario':
        valorA = a.username.toLowerCase();
        valorB = b.username.toLowerCase();
        break;
      case 'email':
        valorA = a.email.toLowerCase();
        valorB = b.email.toLowerCase();
        break;
      case 'status':
        valorA = a.isActive ? 1 : 0;
        valorB = b.isActive ? 1 : 0;
        break;
      default:
        return 0;
    }

    if (valorA < valorB) return ordemAscendente.value ? -1 : 1;
    if (valorA > valorB) return ordemAscendente.value ? 1 : -1;
    return 0;
  });
});

// Função para ordenar por coluna
function ordenarPor(coluna) {
  if (colunaOrdenada.value === coluna) {
    // Inverte a ordem se a mesma coluna for clicada novamente
    ordemAscendente.value = !ordemAscendente.value;
  } else {
    // Define a nova coluna e a ordem ascendente por padrão
    colunaOrdenada.value = coluna;
    ordemAscendente.value = true;
  }
}

onMounted(fetchUsers);

function getUserFullName(user) {
  const firstName = user.first_name || '';
  const lastName = user.last_name || '';
  const fullName = `${firstName} ${lastName}`.trim();
  return fullName || 'Nome não informado';
}

async function fetchUsers() {
  try {
    const response = await apiClient.get('/api/v1/auth/users/');
    users.value = response.data.map(user => ({
      ...user,
      first_name: user.first_name || '',
      last_name: user.last_name || '',
      username: user.username || '',
      email: user.email || '',
      isActive: user.is_active !== undefined ? user.is_active : true
    }));
  } catch (err) {
    error.value = 'Erro ao carregar usuários';
    showBanner('error', 'Erro ao carregar usuários. Tente novamente.');
  }
}

function openModal(user = null) {
  isEditMode.value = !!user;
  if (user) {
    // Em modo de edição, mantém os dados existentes e limpa a senha
    currentUser.value = { ...user, password: '' };
  } else {
    // Para novo usuário, inicializa os campos
    currentUser.value = {
      id: '',
      first_name: '',
      last_name: '',
      email: '',
      password: '',
      isActive: true
    };
  }
  isModalOpen.value = true;
}

function closeModal() {
  isModalOpen.value = false;
}

async function saveUser() {
  if (!isEditMode.value) {
    // Validação dos campos obrigatórios
    if (!currentUser.value.first_name || !currentUser.value.last_name || !currentUser.value.email || !currentUser.value.password) {
      errorMessage.value = "Por favor, preencha todos os campos obrigatórios.";
      showErrorPopup.value = true;
      return;
    }

    if (currentUser.value.password.length < 8) {
      errorMessage.value = "A senha deve ter pelo menos 8 caracteres.";
      showErrorPopup.value = true;
      return;
    }
    
    try {
      await apiClient.post(
        '/api/v1/auth/register/',
        {
          first_name: currentUser.value.first_name,
          last_name: currentUser.value.last_name,
          email: currentUser.value.email,
          password: currentUser.value.password,
        },
      );

      closeModal();
      showBanner('success', 'Usuário criado com sucesso!');
      // Recarrega a lista de usuários para mostrar o novo usuário
      await fetchUsers();
    } catch (err) {
      if (err.response && err.response.status === 400) {
        // Se o erro vier no formato { "detail": "Mensagem de erro" }, extrai apenas a mensagem
        if (typeof err.response.data === "object" && err.response.data.detail) {
          if (Array.isArray(err.response.data.detail)) {
            // Se for um array de erros, pega a primeira mensagem
            const firstError = err.response.data.detail[0];
            errorMessage.value = firstError.msg || "Erro de validação.";
          } else {
            errorMessage.value = err.response.data.detail;
          }
        } else {
          errorMessage.value = err.response.data || "Erro ao cadastrar usuário.";
        }
      } else {
        errorMessage.value = "Erro ao cadastrar usuário. Verifique se todos os campos estão preenchidos corretamente.";
      }
      showErrorPopup.value = true;
    }
  } else {
    await updateUser();
  }
}

async function updateUser() {
  try {
    // Cria o objeto de dados para atualização sem a senha inicialmente
    const updateData = {
      first_name: currentUser.value.first_name,
      last_name: currentUser.value.last_name,
      email: currentUser.value.email,
    };

    // Se a senha for informada, valida o comprimento e inclui no objeto
    if (currentUser.value.password) {
      if (currentUser.value.password.length < 8) {
        error.value = "A senha deve ter pelo menos 8 caracteres.";
        return;
      }
      updateData.password = currentUser.value.password;
    }

    const response = await apiClient.put(
      `/api/v1/auth/users/${currentUser.value.id}/`,
      updateData,
    );
    const updatedUser = response.data;

    // Atualiza o usuário na lista local
    const index = users.value.findIndex(u => u.id === updatedUser.id);
    if (index !== -1) {
      users.value[index] = {
        ...updatedUser,
        first_name: updatedUser.first_name || '',
        last_name: updatedUser.last_name || '',
        username: updatedUser.username || '',
        email: updatedUser.email || '',
        isActive: updatedUser.is_active !== undefined ? updatedUser.is_active : true
      };
    }
    closeModal();
    showBanner('success', 'Usuário atualizado com sucesso!');
  } catch (err) {
    error.value = err.response?.data?.detail || "Erro ao editar usuário";
    showBanner('error', 'Erro ao editar usuário. Tente novamente.');
  }
}

const currentPage = ref(1);
const itemsPerPage = 10; // Quantidade de usuários por página

// Total de páginas com base na quantidade de usuários
const totalPages = computed(() => Math.ceil(users.value.length / itemsPerPage));

// Retorna apenas os usuários da página atual
const paginatedUsers = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage;
  const end = start + itemsPerPage;
  return usuariosOrdenados.value.slice(start, end);
});

// Função para avançar página
function nextPage() {
  if (currentPage.value < totalPages.value) {
    currentPage.value++;
  }
}

// Função para voltar página
function prevPage() {
  if (currentPage.value > 1) {
    currentPage.value--;
  }
}

import { useRouter } from 'vue-router';
const router = useRouter();
const voltar = () => router.go(-1);
  
async function deleteUser(userId) {
  const userToDelete = users.value.find(user => user.id === userId);
  if (userToDelete) {
    deleteConfirmationUser.value = userToDelete;
    isDeleteConfirmationModalOpen.value = true;
  } else {
    showBanner('error', 'Usuário não encontrado.');
  }
}

function closeDeleteConfirmationModal() {
  isDeleteConfirmationModalOpen.value = false;
  deleteConfirmationUser.value = null;
}

function closeStatusConfirmationModal() {
  isStatusConfirmationModalOpen.value = false;
  statusConfirmationData.value = null;
}

async function confirmDeleteUser() {
  if (!deleteConfirmationUser.value) return;

  try {
    await apiClient.delete(`/api/v1/auth/users/${deleteConfirmationUser.value.id}/`);
    users.value = users.value.filter(user => user.id !== deleteConfirmationUser.value.id);
    closeDeleteConfirmationModal();
    showBanner('success', 'Usuário excluído com sucesso!');
  } catch (err) {
    error.value = err.response?.data?.detail || "Erro ao deletar usuário";
    showBanner('error', 'Erro ao excluir usuário. Tente novamente.');
  }
}

async function confirmStatusChange() {
  if (!statusConfirmationData.value) return;

  try {
    await apiClient.patch(
      `/api/v1/auth/users/${statusConfirmationData.value.user.id}/`,
      { is_active: statusConfirmationData.value.newStatus }
    );
    
    // Atualiza o usuário na lista local
    const index = users.value.findIndex(u => u.id === statusConfirmationData.value.user.id);
    if (index !== -1) {
      users.value[index].isActive = statusConfirmationData.value.newStatus;
    }
    
    closeStatusConfirmationModal();
    
    if (statusConfirmationData.value.newStatus) {
      showBanner('success', 'Usuário habilitado com sucesso!');
    } else {
      showBanner('success', 'Usuário desabilitado com sucesso!');
    }
  } catch (err) {
    console.error('Erro ao atualizar status:', err);
    showBanner('error', 'Erro ao atualizar status do usuário. Tente novamente.');
  }
}

const toggleUserActiveFromClick = (user) => {
  // Encontra o checkbox invisível e dispara o evento
  const checkbox = document.querySelector(`#user-checkbox-${user.id}`);
  if (checkbox) {
    checkbox.click();  // Simula o clique no checkbox, disparando o @change corretamente
  }
};

async function toggleUserActive(user, event) {
  if (!event || !event.target) return;

  const newStatus = event.target.checked;
  
  // Se está desabilitando, mostra modal de confirmação
  if (!newStatus) {
    statusConfirmationData.value = {
      user: user,
      newStatus: false
    };
    isStatusConfirmationModalOpen.value = true;
    // Reverte o checkbox até confirmar
    event.target.checked = true;
    return;
  }
  
  // Se está habilitando, mostra modal de confirmação
  statusConfirmationData.value = {
    user: user,
    newStatus: true
  };
  isStatusConfirmationModalOpen.value = true;
  // Reverte o checkbox até confirmar
  event.target.checked = false;
}
</script>

<style>
.clinic-btn {
  background-color: var(--clinic-btn-bg) !important;
  color: #fff !important;
  transition: background 0.2s;
}
.clinic-btn:hover {
  background-color: var(--clinic-btn-bg-hover) !important;
}
.input-font-color, input, select, textarea {
  color: var(--clinic-font-color) !important;
}
</style>